module.exports = "/_next/static/images/smallBackground-fddb2ad68f52bce98cf29f23c4d39a7e.png";